module.exports = __webpack_public_path__ + "static/carousel-text-2.a4a2a1ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Home/carousel-text-2.svg
// module id = 1130
// module chunks = 213534597649335